import { useTranslation } from "react-i18next"
import React, { useRef } from "react"
import { USE_PRODUCTION_REF_DB_URL, useFeatureFlag } from "hooks/useFeatureFlag"
import { useRefDbPathCache } from "hooks/useRefDbPathCache"
import useRefDbSessionToken from "hooks/useRefDbSessionToken"

const ReferenceDatabaseEmbedMolecule = () => {
  const { i18n } = useTranslation()
  const { isFeatureActive } = useFeatureFlag()
  const iframeRef = useRef(null)

  const PRODUCTION_REF_DB_URL = "https://app.ref.verdikt.io"
  const DEV_REF_DB_URL = "https://app.ref.dev.verdikt.io"

  const REF_DB_URL = isFeatureActive(USE_PRODUCTION_REF_DB_URL)
    ? PRODUCTION_REF_DB_URL
    : DEV_REF_DB_URL

  const cachedPath = useRefDbPathCache(REF_DB_URL)
  useRefDbSessionToken(REF_DB_URL, iframeRef)

  const src = cachedPath
    ? `${REF_DB_URL}/${i18n.language}/external/${cachedPath}`
    : `${REF_DB_URL}/${i18n.language}/external`

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title="Reference Database embedded"
      className="referenceDatabasePage__iframe"
      loading="lazy"
    />
  )
}

export default ReferenceDatabaseEmbedMolecule
